import { render, staticRenderFns } from "./otherSearch.vue?vue&type=template&id=6d489093&scoped=true&"
import script from "./otherSearch.vue?vue&type=script&lang=js&"
export * from "./otherSearch.vue?vue&type=script&lang=js&"
import style0 from "./otherSearch.vue?vue&type=style&index=0&id=6d489093&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d489093",
  null
  
)

export default component.exports